import React, { useEffect, useState, useLayoutEffect } from "react";
// import ReactHtmlParser, {
//   processNodes,
//   convertNodeToElement,
//   htmlparser2,
// } from "react-html-parser";
import logoLight from "../../assets/images/logo-light.png";
import moment from "moment";
import parse from "html-react-parser";

const PrintDocBast = ({ innerRef, item }) => {
  const [authUser, setAuthUser] = useState();
  const [logo, setLogo] = useState();
  const [signed, setSigned] = useState();
  const [desc, setDesc] = useState(null);

  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    setAuthUser(obj);
  }, []);

  useEffect(() => {
    if (item.bast) {
      const desc = item.bast.description
        .replace(
          "[service]",
          `<b>${item.data.task_service ? item.data.task_service.name : ""}</b>`
        )
        .replace(
          "[campaignPage]",
          `${(item.data.task_campaignPage || []).map((el, i) => {
            return `<span key=${i}>${el.task_campaignPage_campaignPage.name} </span>`;
          })}`
        )
        .replace("[taskname]", `<h6>${item.data ? item.data.name : ""}</h6>`)
        .replace("[prefix]", `<b>${item.prefix ? item.prefix : ""}</b>`)
        .replace("[dashed]", `<hr/>`)
        .replace(
          "[branch]",
          `<b>${item.data.task_branch ? item.data.task_branch.name : ""}</b>`
        )
        .replace(
          "[company]",
          `<b>${item.data.task_company ? item.data.task_company.name : ""}</b>`
        )
        .replace(
          "[task description]",
          `${item.data.description ? item.data.description : ""}`
        )
        .replace(
          "[unit]",
          `${(item.data.task_unit || []).map((el, i) => {
            return `<span key=${i}>${el.task_unit_unit.name} </span>`;
          })}`
        )
        .replace(
          "[print date]",
          `${moment().format("DD MMMM YYYY")}`
        )
        .replace(
          "[task periode]",
          `${moment(item.data.startat)
            
            .format("DD MMMM YYYY")} - ${moment(item.data.endat)
            
            .format("DD MMMM YYYY")}`
        )
        .replace(
          "[assignto]",
          `<table className='table table-striped'>
      <thead>
        <tr className='table-dark'>
          <th scope='col'>No</th>
          <th scope='col'>Nama</th>
          <th scope='col'>No HP</th>
          <th scope='col'>NIK</th>
          <th scope='col'>Fungsi</th>
        </tr>
      </thead>
      <tbody>
        ${item.data.task_assign.map((el, i) => {
          return `
            <tr key={${i}}>
              <th scope='row'>${i + 1}</th>
              <td>
                ${
                  el.taska_user.user_employee
                    ? el.taska_user.user_employee.name
                    : "-"
                }
              </td>
              <td>
                ${el.taska_user.phone ? el.taska_user.phone : "-"}
              </td>
              <td>
                ${
                  el.taska_user.user_employee.code
                    ? el.taska_user.user_employee.code
                    : "-"
                }
              </td>
              <td>
                ${
                  el.taska_user.user_position
                    ? el.taska_user.user_position.name
                    : "-"
                }
              </td>
            </tr>`;
        })}
      </tbody>
    </table>`
        )
        .replace(
          "[print user]",
          `${(item.data.task_report || []).map((el, i) => {
            let admin;
            if (el.isAdmin) {
              admin = el;
            }
            return `<span key=${i}>${
              admin ? admin.taskr_user.name : ""
            } </span>`;
          })}`
        )
        .replace(
          "[user position]",
          `${(item.data.task_report || []).map((el, i) => {
            let admin;
            if (el.isAdmin) {
              admin = el;
            }
            return `<span key=${i}>${
              admin ? admin.taskr_user.user_position.name : ""
            } </span>`;
          })}`
        )
        .replace(
          "[branch address]",
          `${(
            (item.data.task_branch && item.data.task_branch.branch_address) ||
            []
          ).map((el, i) => {
            return `<span key=${i}>${el.task_branch_address.name} </span>`;
          })}`
        )
        .replace("[to]", `${item.to ? item.to : ""}`);
      setDesc(desc);
    }
  }, [item]);
  if (item.data) {
    return (
      <div
        className=''
        style={{
          overflow: "scroll",
          //backgroundColor: "blue"
        }}>
        <div
          ref={innerRef}
          className='bg-white'
          style={{ padding: "40px 80px 40px 80px" }}>
          <div className='d-flex mb-4'>
            <img
              alt=''
              src={logo}
              style={{ maxWidth: "150px", maxHeight: "50px" }}
              className='me-auto'
            />
            <img
              alt=''
              src={
                process.env.REACT_APP_API_URL +
                "/media/" +
                item.data?.task_client.client_image?.file_folder.name +
                "/" +
                item.data?.task_client.client_image?.filename
              }
              style={{ maxWidth: "150px", maxHeight: "50px" }}
              className='ms-auto'
            />
          </div>
          <div className='text-center fw-bold text-uppercase mb-1'>
            <h6 className='fw-bold'>
              {"BERITA ACARA PEMERIKSAAN UNIT " + item.objek}
            </h6>
            <h6 className='fw-bold'>
              SEBELUM DAN SESUDAH PEMASANGAN/PEMELIHARAAN
            </h6>
            <h6 className='fw-bold'>
              {"MCU (Master Controll Unit) " + item.data?.task_client.name}
            </h6>
          </div>
          {/* <h6 className="fw-bold">{"Bahwa pada tanggal " + moment(item.date).format("DD") + " bulan " + moment(item.date).format("MMMM") + " tahun " + moment(item.date).format("YYYY") + " telah dilaksanakan pemeriksaan bersama sebelum dan sesudah : "}</h6> */}
          <div>{desc ? parse(desc) : "-"}</div>
          <table style={{ border: "1px solid black", width: "100%" }}>
            <tbody>
              <tr style={{ border: "1px solid black" }}>
                <th
                  scope='col'
                  width={150}
                  style={{ border: "1px solid black", padding: "5px" }}>
                  STASIUN/DIPO
                </th>
                <td className='text-center' style={{ padding: "5px" }}>
                  {item.data?.task_unit.name}
                </td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <th
                  scope='row'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  SERI KA PEMBANGKIT
                </th>
                <td style={{ padding: "5px" }}>{item.seri}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <th
                  scope='row'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  NAMA KA
                </th>
                <td style={{ padding: "5px" }}>{item.objek}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <th
                  scope='row'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  NO SERI
                </th>
                <td style={{ padding: "5px" }}>{item.seriObject}</td>
              </tr>
            </tbody>
            {/* <tbody>
              <tr style={{ border: "1px solid black" }}>
                <th scope='row' style={{ border: "1px solid black" }}>
                  NAMA KA
                </th>
                <td>{item.objek}</td>
              </tr>
            </tbody>
            <tbody>
              <tr style={{ border: "1px solid black" }}>
                <th scope='row' style={{ border: "1px solid black" }}>
                  NO.SERI
                </th>
                <td>{item.seriObjek}</td>
              </tr>
            </tbody> */}
          </table>
          <br />
          <table style={{ border: "1px solid black", width: "100%" }}>
            <tbody>
              <tr>
                <td
                  colSpan={3}
                  className='text-center'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  URAIAN PEMERIKSAAN
                </td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <th
                  scope='row'
                  className='text-center'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  PARAMETER
                </th>
                <td
                  className='text-center'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  SEBELUM PEMASANGAN/PEMELIHARAAN
                </td>
                <td
                  className='text-center'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  SETELAH PEMASANGAN/PEMELIHARAAN
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr style={{ border: "1px solid black" }}>
                <th
                  scope='row'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  {"item.name"}
                </th>
                <td
                  className='text-end'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  20000
                </td>
                <td
                  className='text-end'
                  style={{ border: "1px solid black", padding: "5px" }}>
                  40000
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr style={{ border: "1px solid black" }}>
                <th
                  scope='row'
                  style={{ height: "100px", padding: "5px" }}
                  className='d-flex align-items-start'>
                  CATATAN :
                </th>
                <td></td>
                <td
                  className='fw-semibold d-flex align-items-start'
                  style={{ padding: "5px" }}>
                  CATATAN: 
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <div>
            <h6>Kesimpulan</h6>
            <h6>
              1. Kondisi Unit Deepsea sebelum dilakukan pemasangan/pemeliharaan
              MCU adalah NORMAL/TIDAK NORMAL
            </h6>
            <h6>
              2. Kondisi Unit Deepsea setelah dilakukan pemasangan/pemeliharaan
              MCU adalah NORMAL/TIDAK NORMAL
            </h6>
            <h6>Keterangan : </h6>
            <hr className='mb-4' />
            <hr className='mb-4' />
            <hr className='mb-4' />
            <div className='d-flex mb-4'>
              <div className='me-auto'>
                <h6>Disaksikan</h6>
                <img
                  src={
                    process.env.REACT_APP_API_URL +
                    "/media/" +
                    item.data?.task_report[0].taskr_user.user_image_signed
                      ?.file_folder.name +
                    "/" +
                    item.data?.task_report[0].taskr_user.user_image_signed
                      ?.filename
                  }
                  alt=''
                  style={{ maxWidth: "200px" }} />
                <h6>Nama : {item.employee && item.employee.name}</h6>
                <h6>NIP : {item.employee && item.employee.code}</h6>
              </div>
              <div className='d-flex align-items-center gap-4'>
                <div className='ms-auto'>
                  <h6>TEKNISI</h6>
                  <img
                    src={
                      process.env.REACT_APP_API_URL +
                      "/media/" +
                      item.data?.task_assign[0].taska_user.user_image_signed
                        ?.file_folder.name +
                      "/" +
                      item.data?.task_assign[0].taska_user.user_image_signed
                        ?.filename
                    }
                    alt=''
                    style={{ maxWidth: "200px" }}/>
                  <h6>
                    Nama : 
                    {item.data.task_assign.length > 0 &&
                    item.data?.task_assign[0].taska_user.user_employee
                      ? item.data?.task_assign[0].taska_user.user_employee.name
                      : "-"}
                  </h6>
                  <h6>
                    NIK : 
                    {item.data.task_assign.length > 0 &&
                    item.data?.task_assign[0].taska_user.user_employee
                      ? item.data?.task_assign[0].taska_user.user_employee.code
                      : "-"}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default PrintDocBast;
